import { Outlet, useLocation } from "react-router-dom";
import React, { useState } from "react";
import Sidebar from "../common/Sidebar";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";

function Dashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  // Hide Navbar and Footer only on chatbot paths
  const hideLayout =
    location.pathname.startsWith("/dashboard/student/chatbot") ||
    location.pathname.startsWith("/dashboard/teacher/chatbot") ||
    location.pathname.startsWith("/dashboard/chatbot/voicebot");

  return (
    <div className="flex min-h-screen">
      {!hideLayout && (
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="flex flex-col flex-1">
        {!hideLayout && <Navbar onMenuClick={() => setIsSidebarOpen(true)} />}

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

        {!hideLayout && <Footer />}
      </div>
    </div>
  );
}

export default Dashboard;
